<div class="dropdown-with-search">
  <dsy-input-dropdown
    #dd
    [label]="label()"
    [placeholder]="placeholder()"
    [exclusiveSelection]="exclusiveSelection()"
    [closesOnSelection]="closesOnSelection()"
    [entries]="filteredEntries()"
    [customDsyListConfObject]="customDsyListConfObject()"
    [customDsyListContainerStyle]="containerStyle"
    [renderCounterTag]="renderCounterTag()"
    [counterTagConfig]="counterTagConfig()"
  ></dsy-input-dropdown>
  @if (isOpen()) {
    <input
      #searchInput
      class="dropdown-search"
      type="text"
      [placeholder]="searchPlaceholder()"
      [value]="search()"
      (input)="onSearchInput($event)"
      (click)="stopEvent($event)"
      (mousedown)="stopEvent($event)"
    />
  }
</div>
